import { useI18n } from "@/context/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer
      className="border-t border-app-border bg-white/60 px-4 py-3 text-center text-[11px] text-espresso/60 mt-8 no-print"
      data-testid="app-footer"
    >
      {t("footer.copyright").replace("{year}", new Date().getFullYear())}
    </footer>
  );
}
